export { default } from './Slideshow'
export type { SlideshowProps, SlideshowHandler } from './types'
